import GlobalLoader from 'layout/components/globalLoader';
import { createContext, useState, useContext } from 'react';

const LoadingContext = createContext(null);

export const LoadingProvider = ({ children }) => {
  const [globalLoading, setGlobalLoading] = useState(false);

  return (
    <LoadingContext.Provider value={{ globalLoading, setGlobalLoading }}>
      {children}
      <GlobalLoader loading={globalLoading} />
    </LoadingContext.Provider>
  );
};

export const useLoading = () => {
  const context = useContext(LoadingContext);

  return context;
};
